import { executeRequest, Request, Response } from '@jfs/network'

import { Config } from 'react-native-config'
import { getImageUrlPath } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: Response) => {
  const responseObj = data?.data?.responseObject ?? []
  // console.log('responseObj', responseObj)
  return responseObj?.map((item: any, index: number) => {
    return { ...item.order, index: index, logoPath: getImageUrlPath(item?.order?.product?.logoName ?? '') }
  })
}

const returnBody = (jfsUserId: string, startDate: string, endDate: string, limit: string, offset: string) => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
    customerDetails: {
      jfsUserId: jfsUserId,
    },
    config: {
      orderHistoryStartDate: startDate,
      orderHistoryEndDate: endDate,
      limit: limit,
      offset: offset,
    },
  }
}

export const getOrderHistory = (
  jfsUserId: string,
  startDate: string,
  endDate: string,
  limit = '10',
  offset = '0',
  tokens,
  userAccessToken,
  abortController?: any,
) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.getOrderHistory,
    method: 'POST',
    body: returnBody(jfsUserId, startDate, endDate, limit, offset),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    ...{
      abortController: abortController,
    },
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.responseStatus?.code === '000') {
      return responseParser(data)
    }
    throw data
  })
}

const searchBody = (jfsUserId: string, orderId: string) => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
    customerDetails: {
      jfsUserId: jfsUserId,
    },
    order: {
      id: orderId,
    },
  }
}

export const searchByOrderId = (jfsUserId: string, orderId: string, tokens, userAccessToken, abortController?: any) => {
  const config = sitConfig(tokens)
  const request: Request<{}> = {
    apiPath: APIEndPoints.getOrderHistory,
    method: 'POST',
    body: searchBody(jfsUserId, orderId),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    ...{
      abortController: abortController,
    },
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.responseStatus?.code === '000') {
      return responseParser(data)
    }
    throw data
  })
}
